import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import HowItWorksHeroSection from './HowItWorksHeroSection';
import HowItWorksCustomersSection from './HowItWorksCustomersSection';
import HowItWorksBusinessesSection from './HowItWorksBusinessesSection';

const HowItWorksPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <HowItWorksHeroSection />
      <HowItWorksCustomersSection />
      <HowItWorksBusinessesSection />
      <Footer />
    </div>
  );
};

export default HowItWorksPage;
